<div>
  <h2>{{ 'Skapa Barcode' | translate }}</h2>
  <div class="row">
    <div class="col" *ngIf="!preSelectedType">
      <h5>{{ 'Typ' | translate }}</h5>
      <div class="option" *ngFor="let barcodePart of barcodeParts; let i = index"
        [ngClass]="{'selected': i === selectedIndex1}" (click)="selectTypeIndex(i)">{{barcodePart.label}}</div>
    </div>
    <div class="col" *ngIf="!simpleSizeSelector">
      <ng-container *ngIf="barcodeParts[selectedIndex1]">
        <h5>{{barcodeParts[selectedIndex1].groupLabel2}}</h5>
        <div class="option" *ngFor="let barcodePart of barcodeParts[selectedIndex1].group2; let i = index"
          [ngClass]="{'selected': i === selectedIndex2}" (click)="selectIndex2(i)">{{barcodePart.label}}</div>
      </ng-container>
    </div>
    <div class="col" *ngIf="!simpleSizeSelector">
      <ng-container *ngIf="barcodeParts[selectedIndex1]">
        <h5>{{barcodeParts[selectedIndex1].groupLabel3}}</h5>
        <div class="option" *ngFor="let barcodePart of barcodeParts[selectedIndex1].group3; let i = index"
          [ngClass]="{'selected': i === selectedIndex3}" (click)="selectIndex3(i)">{{barcodePart.label}}</div>
      </ng-container>
    </div>

    <div class="col" *ngIf="simpleSizeSelector">
      <ng-container *ngIf="barcodeParts[selectedIndex1]">
        <h5>{{ 'Storlek' | translate }}</h5>
        <div class="option" [ngClass]="{'selected': selectedSimpleSize === '021030'}"
          (click)="selectSimpleSize('021', '030')">{{ '21x30cm' | translate }}</div>

        <div class="option" [ngClass]="{'selected': selectedSimpleSize === '030040'}"
          (click)="selectSimpleSize('030', '040')">{{ '30x40cm' | translate }}</div>

        <div class="option" [ngClass]="{'selected': selectedSimpleSize === '050070'}"
          (click)="selectSimpleSize('050', '070')">{{ '50x70cm' | translate }}</div>

        <div class="option" [ngClass]="{'selected': selectedSimpleSize === '070100'}"
          (click)="selectSimpleSize('070', '100')">{{ '70x100cm' | translate }}</div>
      </ng-container>
    </div>

    <div class="col" >
      <ng-container *ngIf="barcodeParts[selectedIndex1]">
        <h5>{{barcodeParts[selectedIndex1].groupLabel4}}</h5>
        <div class="option" *ngFor="let barcodePart of barcodeParts[selectedIndex1].group4; let i = index"
          [ngClass]="{'selected': i === selectedIndex4}" (click)="selectIndex4(i)">{{barcodePart.label}}</div>
      </ng-container>
    </div>

    <div class="col">
      <ng-container *ngIf="barcodeParts[selectedIndex1]">
        <h5>{{barcodeParts[selectedIndex1].groupLabel5}}</h5>
        <div class="option" *ngFor="let barcodePart of barcodeParts[selectedIndex1].group5; let i = index"
          [ngClass]="{'selected': i === selectedIndex5}" (click)="selectIndex5(i)">{{barcodePart.label}}</div>
      </ng-container>
    </div>
  </div>

  <div class="row">
    <div class="col-12 align-center">
      <br />
      <h3>{{ 'Barcode:' | translate }}</h3>
      <h1>{{getBarcode()}}</h1>
      <button mat-raised-button color="primary" (click)="copy()">{{ 'Kopiera' | translate }}</button>
    </div>
  </div>

</div>
